import i18n from 'i18next'
import React from 'react'
import PropTypes from 'prop-types'
import Headline from '#components/a/Headline'

export default function Greeting(props) {
  const {firstName} = props
  const greetingWithName = i18n.t('meineausbildung_page_title', [firstName])
  const greeting = firstName ? greetingWithName : 'Hallo!'
  return <Headline importance={1} modifier="section" text={greeting} />
}

Greeting.propTypes = {
  firstName: PropTypes.string,
}
